var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificate"},[_c('div',{staticClass:"grid-container"},_vm._l((_vm.certificateListing),function(item){return _c('div',{key:item.id,staticClass:"grid-item certificate-logo"},[_c('img',{attrs:{"src":require('@/'+item.imagePath),"alt":item.alt}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }